import { REPLICATED_OBJECT_PATH } from "../../framework/firebase/DBPathConstants";
import { GameIdFirebaseWrapper } from "../../framework/firebase/GameIdFirebaseWrapper";
import { DataListener } from "../../framework/layer/DataListener";
import { ClassBasedImmutableDataMapper } from "../../framework/layer/DataMapper";
import { DataProvider } from "../../framework/layer/DataProvider";
export function isReplicatedObjectListenerKey(key) {
    const parts = key.split('/');
    if (parts.length < 2) {
        return false;
    }
    return parts[0] === REPLICATED_OBJECT_PATH;
}
export class ReplicatedObjectDataListener extends DataListener {
    constructor(firebase, playerAndGameIdProvider, keyMapping) {
        super({
            firebase,
            listen: {
                listPath: REPLICATED_OBJECT_PATH,
            },
            keyMapping,
        });
        this.firebase = firebase;
        this.playerAndGameIdProvider = playerAndGameIdProvider;
    }
    activate() {
        const { gameId } = this.playerAndGameIdProvider.data;
        this.config.firebase = new GameIdFirebaseWrapper(this.firebase, gameId);
        super.activate();
    }
}
export class ReplicatedObjectViewMapper extends ClassBasedImmutableDataMapper {
    constructor(builderMap, playerAndGameIdProvider, replicatedObjectDataListener) {
        const parentMap = Object.create(null);
        for (const key of Object.keys(builderMap)) {
            parentMap[key] = (_, input, oldData) => builderMap[key](oldData, input, this.playerAndGameIdProvider.data);
        }
        super(parentMap, replicatedObjectDataListener);
        this.playerAndGameIdProvider = playerAndGameIdProvider;
    }
}
export class ReplicatedObjectDataProvider extends DataProvider {
    constructor() {
        super(...arguments);
        this.replicatedObjectViewsById = Object.create(null);
    }
    update(inEvent) {
        if (inEvent.type === 'Created') {
            this.replicatedObjectViewsById[inEvent.newData.id] = inEvent.newData;
        }
        if (inEvent.type === 'Deleted') {
            delete this.replicatedObjectViewsById[inEvent.oldData.id];
        }
        return inEvent;
    }
    getReplicatedObjectById(replicatedObjectId) {
        return this.replicatedObjectViewsById[replicatedObjectId];
    }
}
//# sourceMappingURL=ReplicatedObjectDataLayers.js.map